import { render, staticRenderFns } from "./Movie.vue?vue&type=template&id=15da9981&"
import script from "./Movie.vue?vue&type=script&lang=js&"
export * from "./Movie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15da9981')) {
      api.createRecord('15da9981', component.options)
    } else {
      api.reload('15da9981', component.options)
    }
    module.hot.accept("./Movie.vue?vue&type=template&id=15da9981&", function () {
      api.rerender('15da9981', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/detail/Movie.vue"
export default component.exports